/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const SELECT_PRESET_TIME_DATA_IDS = {
  selectField: 'Form field: Select datetime range',
  selectOption: `Form field option: Datetime preset selection`,
};

export const PRESET_TIME_CUSTOM = 'custom';

export enum PresetTimeUnit {
  'minute' = 'minute',
  'hour' = 'hour',
  'day' = 'day',
}

export type PresetTimeType = {
  amount: number;
  unit: PresetTimeUnit;
};

export const PRESET_TIMES: Array<PresetTimeType> = [
  {
    amount: 15,
    unit: PresetTimeUnit.minute,
  },
  {
    amount: 1,
    unit: PresetTimeUnit.hour,
  },
  {
    amount: 4,
    unit: PresetTimeUnit.hour,
  },
  {
    amount: 8,
    unit: PresetTimeUnit.hour,
  },
  {
    amount: 12,
    unit: PresetTimeUnit.hour,
  },
  {
    amount: 1,
    unit: PresetTimeUnit.day,
  },
];
